import React from "react";
import { useParams } from "react-router-dom";
import { PublicEventDetail } from "../events/PublicEventDetail";

/**
 * Component that reads the slug from the route and passes it to PublicEventDetail
 */
export const PublicEventDetailFromRoute = () => {
  const { slug } = useParams();

  return <PublicEventDetail slug={slug || ""} />;
};
